import { jsx as r } from "react/jsx-runtime";
import { lazy as n, useEffect as e } from "react";
import { ErrorBoundary as a } from "react-error-boundary";
import "../node_modules/@perxis-auto/shared/lib/lib/async/hooks/useAsync.js";
import "../node_modules/markdown-it/lib/rules_core/state_core.js";
import "../node_modules/markdown-it/lib/rules_block/state_block.js";
import "../node_modules/markdown-it/lib/rules_block/html_block.js";
import "../node_modules/markdown-it/lib/rules_inline/state_inline.js";
import "../node_modules/markdown-it/lib/rules_inline/escape.js";
import { LoadingEnum as s } from "../node_modules/@perxis-auto/shared/lib/types/utility/async.js";
import { useStages as d } from "@perxis-auto/trade-in-sdk";
import { useAppContext as c } from "../shared/lib/app/context/appContext.js";
import { AppLayout as l } from "./layouts/AppLayout/AppLayout.js";
import { SuspenseLayout as u } from "./layouts/SuspenseLayout/SuspenseLayout.js";
import { AppProvider as g } from "./providers/AppProvider/AppProvider.js";
import { AppRouter as A } from "./router/AppRouter/AppRouter.js";
import "../shared/assets/styles/main.scss.js";
/* empty css         */
const y = n(() => import("../pages/ErrorStage/index.js")), E = ({ onSuccess: o, onFailure: t, onReset: p }) => {
  const { setAppHandlers: m } = c(), {
    actions: { getStages: f },
    loading: i
  } = d();
  return e(() => {
    i === s.Idle && f();
  }, [i]), e(() => {
    m({
      onSuccess: o,
      onFailure: t,
      onReset: p
    });
  }, [t, p, o, m]), /* @__PURE__ */ r(a, { fallback: /* @__PURE__ */ r(y, {}), children: /* @__PURE__ */ r(u, { children: /* @__PURE__ */ r(l, { children: /* @__PURE__ */ r(A, {}) }) }) });
};
E.Provider = g;
export {
  E as App
};
